<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Import Forms
</h1>

<form>
    <div mat-dialog-content
         class="mat-dialog-content-div">
        <!-- Controls for selecting a file to import (needs to be a .zip file). -->
        <!-- Controls for selecting a file path, if necessary. -->
        <ng-container *ngIf="this.FolderPathNeeded">
            <div class="folder-path-div">
                <span>{{this.StepNumberText(1)}}Select Import Location: </span>
                <button mat-raised-button
                        color="primary"
                        class="select-folder-path-button theme-primary-btn"
                        (click)="this.selectImportFolderPath()">
                    Select ...
                </button>
            </div>

            <div>
                <span>Location:</span>
                <span class="selected-folder-path-span">{{this.SelectedFolderPath}}</span>
            </div>
        </ng-container>

        <div>
            <span>{{this.StepNumberText(2)}}Select Import File(s): </span>

            <ng-container *ngIf="!this.AllowMultipleFiles">
                <input type="file"
                       #file
                       style="display: none"
                       (change)="this.onFileAdded()" />
            </ng-container>
            <ng-container *ngIf="this.AllowMultipleFiles">
                <input type="file"
                       multiple
                       #file
                       style="display: none"
                       (change)="this.onFileAdded()" />
            </ng-container>

            <button [disabled]="this.JobInitiated"
                    mat-raised-button
                    color="primary"
                    [ngClass]="this.FolderPathNeeded ? 'add-file-btn-with-top-margin theme-primary-btn' : 'add-file-btn theme-primary-btn'"
                    (click)="this.selectImportFile()">
                Select File(s) ...
            </button>
        </div>

        <div>
            <span>File(s): </span>
            <span>{{this.SelectedFileName}}</span>
        </div>
    </div>

    <!--
    <div>
        <mat-checkbox [formControl]="this.CheckboxFormControl">Use simple XML format?</mat-checkbox>
    </div>
        -->

    <div class="execution-time-div">
        <span>Execution Time:</span>
        <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
    </div>

    <div class="execution-status-div">
        <span>Execution Status:</span>
        <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.ImportStatus}}</span>
    </div>

    <div class="execution-summary-div">
        <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
           data-placeholder="Details will display here ...">{{this.ExecutionSummaryText}}</p>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="(!this.FileSelected) || (!this.FolderPathSelected) || this.JobInitiated"
                (click)="this.startStructureImport()">
            Start Import ...
        </button>

        <!--[mat-dialog-close]="this.ImportedStructureId"-->
        <button mat-flat-button
                type="submit"
                color="accent"
                [disabled]="!this.JobInitiated"
                (click)="this.dismissClicked()">
            {{this.DismissButtonTitle}}
        </button>

        <button mat-flat-button
                type="submit"
                color="accent"
                [disabled]="!this.JobErrorOccurred"
                (click)="this.copyJobErrorTextToClipboard()">
            Copy Error Text
        </button>

        <button mat-flat-button
                [disabled]="this.JobInitiated"
                style="margin-left: 10px;"
                (click)="this.cancelClicked()">
            Cancel
        </button>
    </div>
</form>
